import { render, staticRenderFns } from "./RaceClassAlignmentPanel.vue?vue&type=template&id=1120bc30&scoped=true"
import script from "./RaceClassAlignmentPanel.vue?vue&type=script&lang=js"
export * from "./RaceClassAlignmentPanel.vue?vue&type=script&lang=js"
import style0 from "./RaceClassAlignmentPanel.vue?vue&type=style&index=0&id=1120bc30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120bc30",
  null
  
)

export default component.exports